import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { MemberVipStateType } from "types/member";

import { extraReducers } from "./member.extraReducers";

export const initialState: MemberVipStateType = {
  isLoading: false,
  dataVipMember: {
    data: {
      total_level: 0,
      current_level: 0,
      next_level: {
        level: 0,
        turnover: "",
        current_turnover: "",
        turnover_percentage: "",
      },
      benefit: {
        birthday_bonus: "",
        upgrade_reward: "",
      },
      rebate: {
        LC: "",
        SL: "",
        SB: "",
        FH: "",
        ES: "",
        BG: "",
        LT: "",
        KN: "",
        CF: "",
        OT: "",
      },
    },
  },
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    //
  },
  extraReducers,
});

export const selectDataVipMember = (state: ApplicationRootState) =>
  state.member.dataVipMember.data;

export const selectIsLoadingVipMember = (state: ApplicationRootState) =>
  state.member.isLoading;

export default memberSlice.reducer;
